/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["select[_ngcontent-%COMP%]{border:1px solid #ccc;background:unset}.button-general-no[_ngcontent-%COMP%], .button-general-yes[_ngcontent-%COMP%]{width:70px;display:inline-block;font-size:11px;padding:5px 1px;border-radius:25px}\n/*# sourceMappingURL=config-integrators.component.css.map*/"];
export { styles as styles };
